import { Component, Input } from '@angular/core';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { FilterService, BaseFilterCellComponent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'int-range-filter',
  template: `
 <kendo-numerictextbox [format]="'###'" 
                          [(ngModel)]="minVal"
(onModelChange)="onChange($event)"
(onChange)="onChange($event)"
      (valueChange)="onChange($event)"
                          [min]="0"></kendo-numerictextbox>
-
 <kendo-numerictextbox [format]="'###'" 
                          [(ngModel)]="maxVal"
(onModelChange)="onChange($event)"
(onChange)="onChange($event)"
      (valueChange)="onChange($event)"
                          [min]="0"></kendo-numerictextbox>
  `
})
export class IntRangeFilterComponent extends BaseFilterCellComponent {

  public get selectedValue(): any {
    const filter = this.filterByField(this.valueField);
    return filter ? filter.value : null;
  }

  @Input() public val: any;
  @Input() public minVal: any = null;
  @Input() public maxVal: any = null;
  @Input() public filter: CompositeFilterDescriptor;
  @Input() public textField: string;
  @Input() public valueField: string;


  constructor(filterService: FilterService) {
    super(filterService);
  }

  public onChange(value: any): void {
    var filters = new Array<FilterDescriptor>();
    if (this.minVal !== null) {
      filters.push(
        { // add a filter for the field with the value
          field: this.valueField,
          operator: 'gte',
          value: this.minVal
        });
    }
    if (this.maxVal !== null) {
      filters.push(
        { // add a filter for the field with the value
          field: this.valueField,
          operator: 'lte',
          value: this.maxVal
        });
    }
    if (filters.length == 0)
      this.removeFilter(this.valueField); // remove the filter
    else
      this.applyFilter(
        {
          logic: "and",
          filters: filters
        }); // update the root filter
  }
}
